import styled from 'styled-components';
import { WHITE, ORANGE } from 'root/theme';

const Menu = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: ${WHITE};
  border-radius: 0 0 8px 8px;
  margin-left: .5rem;
  padding: 10px;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  top: 90px;
  position: absolute;
  border-color: ${ORANGE};
  border-style: solid;
  border-width: 0 1px 1px 1px;
  font-size: 12px;
  cursor: pointer;
  box-shadow: inset 0px 10px 10px -10px rgba(0,0,0,0.15);
`;

export default Menu;
